import {lazyComponent} from 'coreUtils/adapters/lazy';

const NewPasswordPopup = lazyComponent(() => import('./NewPasswordPopup'));

export {NewPasswordPopup as default};
